module.exports = __webpack_public_path__ + "assets/media/finalVideo.97961b28.mp4";